import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { getLastSlugWithoutParams } from '@frontend/common/utils';
import { OpenCategoriesInHeader } from '@shared/menu-categories/store/menu-categories.actions';
import { GoToCategory, GoToProduct, GoToSection } from '@shared/navigation';

@Component({
    selector: 'html-wysiwyg',
    template: `<div #wysiwygText class="html-wysiwyg-container" [innerHTML]="html"></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class HtmlWysiwygComponent implements AfterViewInit {
    @ViewChild('wysiwygText', { read: ElementRef, static: false }) public wysiwygText: ElementRef;

    @Input() public html: string | undefined;

    public linkType: string;

    constructor(
        private readonly store: Store,
    ) {}

    public ngAfterViewInit(): void {
        this.initEvents();
    }

    private isInitializedEvents = false;

    public initEvents(): void {
        if (!this.isInitializedEvents) {
            const el: HTMLDivElement = this.wysiwygText.nativeElement;
            const links = el.querySelectorAll('a');
            // biome-ignore lint/complexity/noForEach: <explanation>
            links.forEach((link) => {
                link.setAttribute('aria-label', getLastSlugWithoutParams(link.href));

                link.addEventListener('click', (event) => {
                    this.onLinkClick(link, event);
                });
            });
            this.isInitializedEvents = true;
        }
    }

    public onLinkClick(link: HTMLElement, event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        const target = link.getAttribute('target');
        const categoryId = link.getAttribute('data-category-id');
        const productId = link.getAttribute('data-product-id');
        const type = link.getAttribute('data-link-type');

        switch (type) {
            case 'category':
                this.openCategory(categoryId, target);
                break;
            case 'menu':
                this.openMenu(categoryId);
                break;
            case 'product':
                this.openProduct(productId, categoryId);
                break;
            case 'section':
                this.openSection(type);
                break;
        }
    }

    public openProduct(productId: string, categoryId: string): void {
        this.store.dispatch(GoToProduct({ productId, categoryId }));
    }

    public openCategory(categoryId: string, target: string): void {
        this.store.dispatch(GoToCategory({ categoryId, newWindow: target === '_blank' }));
    }

    public openMenu(categoryId: string): void {
        this.store.dispatch(OpenCategoriesInHeader({ categoryId }));
    }

    public openSection(type: string): void {
        this.store.dispatch(GoToSection({ url: type }));
    }
}
